import type {CloseButtonProps} from '@chakra-ui/react';
import {useAlertStyles} from '@chakra-ui/react';
import type {FC} from 'react';

import {RemoveIconButton} from '../IconButton';

import {useAlertContext} from './context';
import {parts} from './theme/anatomy';

export const AlertCloseButton: FC<CloseButtonProps> = props => {
  const {close} = useAlertStyles();
  const context = useAlertContext();
  const size = context.size === `lg` ? `md` : `sm`;
  return <RemoveIconButton sx={close} size={size} {...props} {...parts.close.attrs} />;
};
